export default function dashboards(podeAcessar) {
  return [
    {
      name: 'Inicio',
      icon: 'fa fa-th-large fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/dash/inicio',
    },
    {
      name: 'Metas e Performance',
      icon: 'fa fa-bar-chart fa-fw',
      type: 'collapse',
      ativo: !(
        podeAcessar('dash.metas.empresa') == false &&
        podeAcessar('dash.metas.equipe') == false &&
        podeAcessar('dash.metas.individual') == false &&
        podeAcessar('dash.metas.config') == false
      ),
      children: [
        {
          name: 'Empresa',
          type: 'item',
          ativo: podeAcessar('dash.metas.empresa'),
          link: '/app/dash/metas/empresa',
        },
        {
          name: 'Equipe',
          type: 'item',
          ativo: podeAcessar('dash.metas.equipe'),
          link: '/app/dash/metas/equipe',
        },
        {
          name: 'Individual',
          type: 'item',
          ativo: podeAcessar('dash.metas.individual'),
          link: '/app/dash/metas/individual',
        },
        {
          name: 'Parametrizações',
          type: 'item',
          ativo: podeAcessar('dash.metas.config'),
          link: '/app/dash/metas/config',
        },
      ],
    },
    {
      name: 'Gerencial',
      badge: 'NOVO',
      icon: 'fa fa-line-chart fa-fw',
      type: 'collapse',
      ativo:
        !(podeAcessar('dash.gerencial.geral_carteiras') == false) ||
        !(podeAcessar('dash.gerencial.gestao_acordos') == false),
      children: [
        {
          name: 'Visão Geral das Carteiras',
          type: 'item',
          ativo: podeAcessar('dash.gerencial.geral_carteiras'),
          link: '/app/dash/gerencial/visao-geral-carteiras',
        },
        {
          name: 'Acordos e Recuperação',
          type: 'item',
          ativo: podeAcessar('dash.gerencial.gestao_acordos'),
          link: '/app/dash/gerencial/gestao-acordos',
        },
      ],
    },
  ];
}
